export interface IMessageTypeListItem {
    id: string;
    code: string;
    name: string;
    typeClass: number;
    image: string;
}

export class MessageTypeListItem implements IMessageTypeListItem {
    id: string;
    code: string;
    name: string;
    typeClass: number;
    image: string;

    constructor();
    constructor(obj: IMessageTypeListItem);
    constructor(obj?: any) {
        this.id = obj && obj.id || "";
        this.code = obj && obj.code || "";
        this.name = obj && obj.name || "";
        this.typeClass = obj && obj.typeClass || 0;
        this.image = obj && obj.image || "";
    }
}